import React, { useState, useEffect, useMemo } from 'react';
import chromeIcon from './assets/chrome-icon.png';
import closeIcon from './assets/close-icon.png';
import { getBrowserVersion, compareVersions, LibBrowserList, ComfyBrowserList } from '@shakkerai/util-cookie';
import { translate } from '@shakkerai/util-i18n';

export const useBrowserTips = () => {
  const [show, setShow] = useState(false);
  // 提示类型，1:浏览器不兼容、2: 版本不兼容
  const [tipType, setTipType] = useState(1);
  useEffect(() => {
    const currentInfo = getBrowserVersion();
    const isComfy = /comfy/i.test(location.pathname);
    const lowestVersions = isComfy ? ComfyBrowserList : LibBrowserList;
    const validInfo = lowestVersions.find((item) => item?.name?.toLowerCase() === currentInfo?.name?.toLowerCase());
    if (!validInfo) {
      setShow(true);
      setTipType(1);
    } else {
      const isLowerVersion = compareVersions(currentInfo?.version, validInfo?.version) < 0;
      if (isLowerVersion) {
        setShow(true);
        setTipType(2);
      }
    }
  }, []);

  const tipNode = useMemo(() => {
    if (tipType === 1) {
      return (
        <span>
          {translate('tip_change_browser_1')}
          <img
            src={chromeIcon}
            style={{ verticalAlign: '-5px' }}
            className="inline-block w-[20px] h-[20px] mx-[4px]"
          ></img>
          {translate('tip_change_browser_2')}
        </span>
      );
    }
    return <span>{translate('tip_update_browser_version_text')}</span>;
  }, [tipType]);

  return {
    isShow: show,
    TipNode: () => {
      return (
        <div className="browser-tip-wrapper fixed top-0 left-0 flex w-full h-[40px] justify-center items-center relative bg-[#0F342E] text-[14px] text-[#FFF]">
          {tipNode}
          <span
            className="absolute inline-block w-[12px] h-[12px] cursor-pointer top-[14px] right-[40px]"
            onClick={() => setShow(false)}
          >
            <img className="w-full h-full" src={closeIcon} alt="" />
          </span>
        </div>
      );
    },
    onClose: () => setShow(false),
  };
};
